import { useMemo } from "react";
import { useUserPermissions } from "../../context/hooks";
import { isSuperAdmin } from "../helpers";
export var useIsSuperAdmin = function () {
    var permissions = useUserPermissions();
    return useMemo(function () { return isSuperAdmin(permissions); }, [permissions]);
};
